// Limits for the KYC image pre-check. Starting values, to be tuned on real
// photos.
// Uploads are often compressed, so a few limits are looser for them.

export const ANALYSIS_WIDTH = 1000;

export const THRESHOLDS = {
  camera: {
    minBlurVariance: 60,
    minShortSide: 600,
  },
  upload: {
    minBlurVariance: 40,
    minShortSide: 500,
  },
  // Average brightness 0-255.
  minBrightness: 55,
  maxBrightness: 215,
  // A pixel at or above this brightness counts as glare.
  glarePixelValue: 250,
  // Fail if this share of all card pixels is glare...
  maxGlareRatio: 0.02,
  // ...or if any one cell of an 8x8 grid over the card is this much glare.
  maxGlareCellRatio: 0.3,
  // Card detection (OpenCV).
  minCardAreaRatio: 0.15,
  // Document shape: each side at least this share of the photo's short side,
  // opposite sides within this ratio of each other (allows for tilt), and
  // long/short side at most this (ID card 1.59, passport page 1.42).
  minCardSideRatio: 0.15,
  minOppositeSideRatio: 0.7,
  maxCardAspect: 2.0,
  // A card covering this much of the image is treated as a tight crop.
  tightCropAreaRatio: 0.9,
  // Corners closer than this share of the image size to an edge mean cut off.
  edgeMarginRatio: 0.01,
};

// After this many rejections in a row, the user may send the photo anyway.
export const MAX_REJECTIONS_BEFORE_OVERRIDE = 3;
